<dcr-top-app-bar [headline]="pageTitle$ | async" class="w-full" [alignment]="(isOnHomeRoute$ | async) ? 'center' : 'start'">
  @if (!(isDesktop$ | async)) {
    <dcr-inline-icon-button icon="shared:menu" slot="navigation-button" aria-label="Menu" (click)="toggleMenu()"></dcr-inline-icon-button>
  }

  @if (isOnHomeRoute$ | async) {
    <dcr-logo slot="full-logo" logo="logo:banner" class="shrink-0"></dcr-logo>
  } @else {
    <a [routerLink]="websiteUrl" slot="tiny-logo" id="platform-header-logo" class="[ relative outline-none flex shrink-0 ]">
      <dcr-logo logo="logo:square"></dcr-logo>
      <dcr-focus-ring for="platform-header-logo"></dcr-focus-ring>
    </a>
    @if (!(isHandset$ | async)) {
      @if (breadcrumbs$ | async; as breadcrumbs) {
        @if (breadcrumbs.length > 0) {
          <campus-breadcrumbs-v2 [breadcrumbs]="breadcrumbs" slot="breadcrumbs"></campus-breadcrumbs-v2>
        }
      }
    }
  }

  @if (isOnV2SchoolDetailRoute$ | async) {
    <div slot="actions" class="[ flex gap-2xs p-i-s ]">
      <campus-select label="Actieve school" placeholder="Selecteer school" [formControl]="schoolForm?.controls?.currentSchool">
        @for (school of schools$ | async; track school) {
          <campus-select-option [value]="school" [label]="school.name"></campus-select-option>
        }
      </campus-select>
    </div>
  }

  <div slot="actions" class="[ flex gap-m ]">
    @if (!(isHandset$ | async)) {
      <div class="[ flex items-center ]">
        <dcr-inline-icon-button
          *hasPermission="[Permissions.GEOGEBRA, '!' + Permissions.HIDE_IN_ARCHIVE]"
          icon="app:calculator"
          aria-label="Rekentoestel"
          (click)="openCalculator()"
        ></dcr-inline-icon-button>
        @if (this.enableGlobalSearch) {
          <a
            *hasPermission="[Permissions.GLOBAL_SEARCH, '!' + Permissions.HIDE_IN_ARCHIVE]"
            navigation-rail-item
            icon="magnifier"
            label="Zoeken"
            data-cy="btn-header-search"
            (click)="onGlobalSearchClick()"
          ></a>
        }
        <a
          *hasPermission="[Permissions.MANAGE_FAVORITES, '!' + Permissions.HIDE_IN_ARCHIVE]"
          navigation-rail-item
          icon="favorite"
          label="Favorieten"
          data-cy="btn-header-favorites"
          (click)="onManageFavoritesClick()"
        ></a>
        <a
          *hasPermission="[Permissions.MANAGE_HISTORY, '!' + Permissions.HIDE_IN_ARCHIVE]"
          navigation-rail-item
          icon="history"
          label="Geschiedenis"
          data-cy="btn-header-history"
          (click)="onManageHistoryClick()"
        ></a>
      </div>
    }
    @if (currentUser$ | async; as user) {
      <div class="[ relative ][ self-center ]">
        <dcr-avatar
          class="[ cursor-pointer ]"
          [firstName]="user.firstName"
          [lastName]="user.name"
          [imageUrl]="user.avatar"
          [showMenu]="true"
          [showInitials]="!user.avatar"
          activity="online"
          data-cy="btn-header-profile"
          content-direction="ltr"
          id="header-profile-avatar"
        ></dcr-avatar>
        <dcr-menu anchor="header-profile-avatar" positioning="popover" has-overflow>
          @for (menuItem of avatarMenuItems$ | async; track menuItem) {
            @if (menuItem.children && menuItem.children.length) {
              <dcr-sub-menu preferred-direction="start">
                <dcr-menu-item slot="item" [label]="menuItem.description" [leadingIcon]="menuItem.icon"></dcr-menu-item>
                <dcr-menu slot="menu" positioning="popover">
                  @for (childItem of menuItem.children; track childItem) {
                    <dcr-menu-item
                      [label]="childItem.description"
                      [leadingIcon]="childItem.icon"
                      [type]="menuItem.internalLink || menuItem.externalLink ? 'link' : 'menuitem'"
                      [campusRouterLink]="menuItem.internalLink || menuItem.externalLink"
                      [attr.selected]="childItem.selected || undefined"
                      (click)="childItem.handler && childItem.handler()"
                    ></dcr-menu-item>
                  }
                </dcr-menu>
              </dcr-sub-menu>
            }
            @if (!menuItem?.children?.length) {
              <dcr-menu-item
                [label]="menuItem.description"
                [leadingIcon]="menuItem.icon"
                [type]="menuItem.internalLink || menuItem.externalLink ? 'link' : 'menuitem'"
                [campusRouterLink]="menuItem.internalLink || menuItem.externalLink"
                [selected]="menuItem.selected"
                (click)="menuItem.handler && menuItem.handler()"
              ></dcr-menu-item>
            }
          }
        </dcr-menu>
      </div>
    }
  </div>
</dcr-top-app-bar>

<campus-slideout-modal-stack [activePanel]="activeHistoryPanel" *hasPermission="Permissions.MANAGE_HISTORY">
  <campus-slideout-modal title="Recente items" (scrimClicked)="closeHistoryPanel()">
    <campus-slideout-modal-header-actions>
      <dcr-inline-icon-button icon="app:close" (click)="closeHistoryPanel()"></dcr-inline-icon-button>
    </campus-slideout-modal-header-actions>

    <campus-quick-link [mode]="QuickLinkTypeEnum.HISTORY" (close)="closeHistoryPanel()"></campus-quick-link>
  </campus-slideout-modal>
</campus-slideout-modal-stack>

<campus-slideout-modal-stack [activePanel]="activeFavoritesPanel" *hasPermission="Permissions.MANAGE_FAVORITES">
  <campus-slideout-modal data-cy="favorites-panel" title="Favorieten" (scrimClicked)="closeFavoritesPanel()">
    <campus-slideout-modal-header-actions>
      <dcr-inline-icon-button icon="app:close" (click)="closeFavoritesPanel()" data-cy="btn-close-favorites-panel"></dcr-inline-icon-button>
    </campus-slideout-modal-header-actions>

    <campus-quick-link [mode]="QuickLinkTypeEnum.FAVORITES" (close)="closeFavoritesPanel()"></campus-quick-link>
  </campus-slideout-modal>
</campus-slideout-modal-stack>
